/* eslint-disable */
import StarItem from "./StarItem";

class Star {
  constructor(scene) {
    this.scene = scene;

    this.root = BABYLON.MeshBuilder.CreateGround(
      "root",
      { width: 0.01, height: 0.01 },
      this.scene
    );
    this.root.visibility = 0;

    this.starList;
  }

  // create stars
  create() {
    this.starList = [];

    for (let s = 0; s < 500; s++) {
      let starItem = new StarItem(this.scene);
      starItem.getMesh().parent = this.root;
      this.starList.push(starItem);
    }
  }

  // delete stars
  reset() {
    for (let s = 0; s < 500; s++) {
      this.starList[s].finalize();
      delete this.starList[s];
    }

    this.starList = [];
  }

  getRoot() {
    return this.root;
  }
}
export default Star;
